const s=new Map,o=(n,t)=>(s.set(n,t),t);export{o as illustration,s as illustrations};
